var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-theme-provider",
    {
      attrs: {
        dark: _vm.effectiveAppearance === "dark",
        light: _vm.effectiveAppearance === "light"
      }
    },
    [
      _c(
        "main",
        {
          staticClass: "payment-page",
          class: _vm.brandClasses,
          style: _vm.brandStyle
        },
        [
          !_vm.isReady
            ? _c(
                "section",
                { staticClass: "payment-loading", attrs: { role: "status" } },
                [
                  _c("v-progress-circular", {
                    attrs: {
                      indeterminate: "",
                      size: 34,
                      width: 3,
                      color: "primary"
                    }
                  }),
                  _c("p", [_vm._v(_vm._s(_vm.$t("invoices.payment.loading")))])
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "payment-shell" },
                [
                  _c("header", { staticClass: "payment-brand" }, [
                    _vm.logo
                      ? _c("img", { attrs: { src: _vm.logo, alt: "Logo" } })
                      : _vm._e()
                  ]),
                  _c(
                    "section",
                    {
                      staticClass: "invoice-summary",
                      attrs: { "aria-labelledby": "payment-heading" }
                    },
                    [
                      _c("div", { staticClass: "summary-heading" }, [
                        _c("span", { staticClass: "invoice-kicker" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("invoices.list.invoice-number")) +
                              " " +
                              _vm._s(_vm.paymentInfo.invoiceNumberFormatted) +
                              " "
                          )
                        ]),
                        _c("h1", { attrs: { id: "payment-heading" } }, [
                          _vm._v(_vm._s(_vm.$t("invoices.payment.options")))
                        ])
                      ]),
                      _c("div", { staticClass: "amount-summary" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("invoice.details.total-due")))
                        ]),
                        _c("strong", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$formatters.dollars(
                                  _vm.paymentInfo.invoiceAmount,
                                  true,
                                  true,
                                  _vm.paymentInfo.currency
                                )
                              ) +
                              " "
                          )
                        ])
                      ]),
                      _c("dl", { staticClass: "invoice-facts" }, [
                        _c("div", [
                          _c("dt", [
                            _vm._v(
                              _vm._s(_vm.$t("invoices.list.invoice-number"))
                            )
                          ]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(_vm.paymentInfo.invoiceNumberFormatted)
                            )
                          ])
                        ]),
                        _c("div", [
                          _c("dt", [
                            _vm._v(_vm._s(_vm.$t("invoice.details.issued")))
                          ]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(
                                _vm.DateTime.fromISO(
                                  _vm.paymentInfo.dateSent
                                ).toLocaleString(_vm.DateTime.DATE_MED)
                              )
                            )
                          ])
                        ]),
                        _c("div", [
                          _c("dt", [
                            _vm._v(_vm._s(_vm.$t("invoice.details.due")))
                          ]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(
                                _vm.DateTime.fromISO(
                                  _vm.paymentInfo.dateDue
                                ).toLocaleString(_vm.DateTime.DATE_MED)
                              )
                            )
                          ])
                        ])
                      ])
                    ]
                  ),
                  _vm.paymentInfo.stripeCardFeeAmount > 0 && _vm.showPaymentForm
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "payment-fee-notice",
                          attrs: { dense: "", text: "", color: "info" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("invoices.payment.card-fee-notice", {
                                  fee: _vm.$formatters.dollars(
                                    _vm.paymentInfo.stripeCardFeeAmount,
                                    true,
                                    true,
                                    _vm.paymentInfo.currency
                                  )
                                })
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "section",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.showPaymentForm,
                          expression: "!showPaymentForm"
                        }
                      ],
                      staticClass: "payment-option-grid",
                      class: "option-count-" + _vm.paymentOptionCount
                    },
                    [
                      _vm.achEnabled || _vm.paymentMethods.length
                        ? _c(
                            "article",
                            { staticClass: "payment-option-card" },
                            [
                              _c("header", { staticClass: "option-heading" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "option-icon",
                                    attrs: { "aria-hidden": "true" }
                                  },
                                  [
                                    _c("portal-icon", {
                                      attrs: { name: "credit-card", size: 20 }
                                    })
                                  ],
                                  1
                                ),
                                _c("h2", [
                                  _vm._v(_vm._s(_vm.$t("invoices.payment.ach")))
                                ]),
                                _c(
                                  "button",
                                  {
                                    staticClass: "option-action",
                                    attrs: {
                                      type: "button",
                                      "aria-label": _vm.$t(
                                        "invoices.payment.ach"
                                      )
                                    },
                                    on: { click: _vm.editSavedPaymentMethods }
                                  },
                                  [
                                    _c("portal-icon", {
                                      attrs: { name: "settings", size: 18 }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm.paymentMethods.length
                                ? _c(
                                    "div",
                                    { staticClass: "saved-method-list" },
                                    _vm._l(_vm.paymentMethods, function(
                                      account
                                    ) {
                                      return _c(
                                        "button",
                                        {
                                          key: account.id,
                                          staticClass: "saved-method",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              return _vm.confirmPayment(account)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "saved-method-icon",
                                              attrs: { "aria-hidden": "true" }
                                            },
                                            [
                                              _c("portal-icon", {
                                                attrs: {
                                                  name: _vm.paymentMethodIcon(
                                                    account
                                                  ),
                                                  size: 19
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "saved-method-details"
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(_vm._s(account.label))
                                              ]),
                                              _c("span", [
                                                _vm._v(
                                                  "•••• " +
                                                    _vm._s(account.last4)
                                                )
                                              ])
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "saved-method-action"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "invoices.payment.pay-with"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              _c("portal-icon", {
                                                attrs: {
                                                  name: "arrow-right",
                                                  size: 17
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : _c("p", { staticClass: "empty-methods" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "invoices.payment.no-linked-accounts"
                                        )
                                      )
                                    )
                                  ]),
                              _vm.achEnabled
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "secondary-payment-action",
                                      attrs: { type: "button" },
                                      on: { click: _vm.initializeACHLink }
                                    },
                                    [
                                      _c("portal-icon", {
                                        attrs: { name: "plus", size: 17 }
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "invoices.payment.new-linked"
                                            )
                                          ) +
                                          " "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "payment-provider" }, [
                                _c("img", {
                                  attrs: {
                                    src: "/images/invoices/stripe-logo.svg",
                                    alt: ""
                                  }
                                }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("invoices.payment.stripe"))
                                  )
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm.cardEnabled
                        ? _c(
                            "article",
                            { staticClass: "payment-option-card" },
                            [
                              _c("header", { staticClass: "option-heading" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "option-icon",
                                    attrs: { "aria-hidden": "true" }
                                  },
                                  [
                                    _c("portal-icon", {
                                      attrs: { name: "credit-card", size: 20 }
                                    })
                                  ],
                                  1
                                ),
                                _c("h2", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("invoices.payment.payment-options")
                                    )
                                  )
                                ])
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "card-brand-row",
                                  attrs: { "aria-hidden": "true" }
                                },
                                [
                                  _c("payment-icon", {
                                    attrs: { size: "34", name: "amex" }
                                  }),
                                  _c("payment-icon", {
                                    attrs: { size: "34", name: "master_card" }
                                  }),
                                  _c("payment-icon", {
                                    attrs: { size: "34", name: "visa" }
                                  }),
                                  _c("payment-icon", {
                                    attrs: { size: "34", name: "discover" }
                                  })
                                ],
                                1
                              ),
                              _c("div", { staticClass: "wallet-options" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("invoices.payment.apple-pay"))
                                  )
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("invoices.payment.google-pay")
                                    )
                                  )
                                ])
                              ]),
                              _c(
                                "button",
                                {
                                  staticClass: "primary-payment-action",
                                  attrs: { type: "button" },
                                  on: { click: _vm.showInlinePayment }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("invoice.pay-now")) +
                                      " "
                                  ),
                                  _c("portal-icon", {
                                    attrs: { name: "arrow-right", size: 18 }
                                  })
                                ],
                                1
                              ),
                              _c("div", { staticClass: "payment-provider" }, [
                                _c("img", {
                                  attrs: {
                                    src: "/images/invoices/stripe-logo.svg",
                                    alt: ""
                                  }
                                }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("invoices.payment.stripe"))
                                  )
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "article",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.payPalEnabled,
                              expression: "payPalEnabled"
                            }
                          ],
                          staticClass: "payment-option-card"
                        },
                        [
                          _c("header", { staticClass: "option-heading" }, [
                            _c(
                              "span",
                              {
                                staticClass: "option-icon paypal-icon",
                                attrs: { "aria-hidden": "true" }
                              },
                              [_vm._v("P")]
                            ),
                            _c("h2", [_vm._v("PayPal")])
                          ]),
                          _c("div", {
                            staticClass: "paypal-button-container",
                            attrs: { id: "paypal-button-container" }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm.showPaymentForm
                    ? _c(
                        "section",
                        { staticClass: "payment-form-card" },
                        [
                          _c(
                            "header",
                            { staticClass: "payment-form-heading" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "back-action",
                                  attrs: {
                                    type: "button",
                                    "aria-label": _vm.$t(
                                      "invoices.payment.options"
                                    )
                                  },
                                  on: { click: _vm.destroyPaymentElement }
                                },
                                [
                                  _c("portal-icon", {
                                    attrs: { name: "arrow-left", size: 18 }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "payment-provider payment-provider-top"
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/images/invoices/stripe-logo.svg",
                                      alt: ""
                                    }
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("invoices.payment.stripe"))
                                    )
                                  ])
                                ]
                              )
                            ]
                          ),
                          _c("div", { ref: "paymentElement" }),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "primary-payment-action stripe-submit",
                              attrs: {
                                loading: _vm.paymentProcessing,
                                disabled: _vm.paymentProcessing
                              },
                              on: { click: _vm.submitPayment }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("invoice.pay-now")) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }